/**
 * Het getal achter het tabblad 'Onderzoek' in een huisbezoek.
 *
 * Telt twee bronnen: de onderzoeken van de eigen organisatie waaraan dit
 * huishouden meedoet (met de hand gekoppeld óf via de schakelaar op het
 * onderzoek), en de vragenlijst van het programma waar het huishouden in
 * meedraait. Zolang de onderzoekenlijst onderweg is komt er geen getal —
 * een '0' zou beweren dat er niets is terwijl dat nog niet bekend is.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} [args]
 * @param {Array<string>} [args.ids] - De effectieve onderzoek-id's (`useEffectiveResearchIds`)
 * @param {boolean} [args.loaded] - Is de onderzoekenlijst binnen?
 * @param {boolean} [args.hasProgramme] - Draagt een deelname-rij een programmavragenlijst?
 * @returns {number|null} `null` = geen getal tonen
 */
const householdResearchTabCount = ({ ids, loaded, hasProgramme } = {}) => {
    if (!loaded) return null
    const count = (Array.isArray(ids) ? ids.length : 0) + (hasProgramme ? 1 : 0)
    return count || null
}

export default householdResearchTabCount
